import React from 'react';
import {Redirect} from 'react-router-dom';

import User from 'Services/User';

/**
 * @function Guest
 * @param {*|JSX.Element} component
 * @return {*|JSX.Element}
 * @constructor
 */
const Guest = ({component}) => {
    const auth = User.loggedIn;

    let redirect = '/';

    if (auth && User.belongsToGroup('Lite')) {
        redirect = '/main-stage/remote';
    } else {
        redirect = '/settings/profile';
    }

    return !auth ? component : <Redirect to={redirect} />;
};

export default Guest;
